import HoldSecondsControl from "./HoldSecondsControl";
import RepPrescriptionControl from "./RepPrescriptionControl";
import RirControl from "./RirControl";

// Tier-3 builder presentation seam (Phase 7A).
//
// One editable set row: its ordinal, its D36 rep prescription, its RIR and --
// where the block allows it -- its remove control. Presentation only. Set
// identity, `setIndex` semantics, `MAX_BLOCK_SET_COUNT`, draft state, mutation
// timing and every persistence concern stay in the container.
export default function SetRow({
  setNumber,
  prescription,
  repDrafts,
  rirValue,
  disabled = false,
  rowClassName = "",
  label,
  measurementType = "REPS",
  onRepFieldFocus,
  onRepFieldChange,
  onRepFieldBlur,
  onCycleRir,
  onRemove,
  canRemove = false,
}) {
  const isTimed = measurementType === "TIMED_HOLD";
  const PrescriptionControl = isTimed
    ? HoldSecondsControl
    : RepPrescriptionControl;
  const prescriptionControl = (
    <PrescriptionControl
      prescription={prescription}
      drafts={repDrafts}
      disabled={disabled}
      label={label}
      onFieldFocus={onRepFieldFocus}
      onFieldChange={onRepFieldChange}
      onFieldBlur={onRepFieldBlur}
    />
  );

  const rirControl = isTimed ? null : (
    <RirControl
      value={rirValue}
      disabled={disabled}
      onCycle={onCycleRir}
    />
  );

  return (
    <div className={[
      "lz-builder-set-row",
      isTimed && "lz-builder-set-row--timed",
      rowClassName,
    ].filter(Boolean).join(" ")}>
      <span className="lz-builder-set-row__index">{setNumber}</span>
      <div className="lz-builder-set-row__prescription">{prescriptionControl}</div>
      <div className="lz-builder-set-row__rir">{rirControl}</div>
      <div className="lz-builder-set-row__trailing">
        {onRemove ? (
          <button
            type="button"
            onClick={onRemove}
            disabled={disabled || !canRemove}
            className="lz-builder-set-row__remove"
            aria-label="Remove set"
          >
            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path d="M4 4l8 8M12 4l-8 8" />
            </svg>
          </button>
        ) : null}
      </div>
    </div>
  );
}
